import ButtonComponent from './ButtonComponent';

const ButtonChargeComponent = (props)=>{
    return (        
        <ButtonComponent onClick={props.onClick} className="ml-3 mr-4 mt-4 bg-red-600 rounded-md font-medium text-white h-12">
            {props.name}
        </ButtonComponent>
    )
}
export default ButtonChargeComponent;